import { render, staticRenderFns } from "./RoleResource.vue?vue&type=template&id=3ab6cb6c"
import script from "./RoleResource.vue?vue&type=script&lang=js"
export * from "./RoleResource.vue?vue&type=script&lang=js"
import style0 from "./RoleResource.vue?vue&type=style&index=0&id=3ab6cb6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports